import { BinaryOperation } from './binaryOperation';
export class PowerOperation extends BinaryOperation {
    constructor(tensorConstructor, dtype, allocator) {
        super(tensorConstructor, dtype, allocator);
    }
    getOp(a, b) {
        return `pow(${a}, ${b})`;
    }
}
//# sourceMappingURL=power.js.map